import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import {
  START_TINT_SERVICE,
  SET_INITIAL_TINT_VALUES,
  DELETE_COLOR_FROM_COOKIE,
  SET_IS_TINT_SERVICE_AVAILABLE,
  DELETE_ACTIVE_COLOR_FROM_SELECTED_COLORS,
} from 'features/product-info/ducks/product-tint-service';
import { getActiveTintColor, getProductId } from 'features/product-info';
import {
  TServiceCookie,
  TTintColorWithQuantity,
  TTintService,
} from 'features/product-info/components/pdp-select-tint-color';
import { TINT_SERVICE_IDS } from 'features/product-info/components/pdp-select-tint-color/pdp-select-tint-color.const';
import { getCookie } from 'utils';
import { getTintServicesFromCookies } from '../helpers/get-tint-services-from-cookies';
import { handleBasketItemFlow } from '../basket';
import { COOKIE_KEY_FOR_SERVICES } from '../handle-update-tint-service-in-service-basket';

export function* rootSaga() {
  yield all([
    takeEvery(START_TINT_SERVICE, () => startTintServices()),
    takeEvery(DELETE_COLOR_FROM_COOKIE, () => deleteTintServiceFromCookies()),
  ]);
}

export function* startTintServices() {
  const serviceCookies = getCookie(COOKIE_KEY_FOR_SERVICES) || '';
  const parsedServicesFromCookies: TServiceCookie[] =
    serviceCookies.length > 0 ? JSON.parse(decodeURIComponent(serviceCookies)) : [];

  let tintServicesForCurrentProduct: Required<TTintService>[] = [];

  if (parsedServicesFromCookies.length > 0) {
    const currentProductId: string = yield select(getProductId) ?? '';

    tintServicesForCurrentProduct = getTintServicesFromCookies({
      productCode: currentProductId,
      tintServiceIds: TINT_SERVICE_IDS,
      parsedServicesFromCookies: parsedServicesFromCookies,
    }) as Required<TTintService>[];
  }

  yield put(SET_INITIAL_TINT_VALUES(tintServicesForCurrentProduct));

  const isTintServicesAvailableForProduct = tintServicesForCurrentProduct.length > 0;

  if (isTintServicesAvailableForProduct) {
    yield put(SET_IS_TINT_SERVICE_AVAILABLE(true));
  }
}

export function* deleteTintServiceFromCookies() {
  const productId: string = yield select(getProductId) || '';

  const activeTintColor: TTintColorWithQuantity | null = yield select(getActiveTintColor);

  if (activeTintColor) {
    yield call(handleBasketItemFlow, {
      payload: {
        productId,
        flowQty: -activeTintColor.serviceQuantity,
      },
    });
    yield put(DELETE_ACTIVE_COLOR_FROM_SELECTED_COLORS());
  }
}
